<div class="register form-frame wide">
  <app-logo></app-logo>

  <div class="form-frame__body">

    <app-progress
      [percent]="'100'">
    </app-progress>

    <div class="form-frame__body-head">
      <app-back-button></app-back-button>
      <h2 class="headline">{{'AGREEMENT.TITLE' | translate}}</h2>
    </div>

    <p
      class="form-frame__body-description">
      {{'AGREEMENT.DESCRIPTION' | translate}}
    </p>

    <div class="form-frame__body-inputs">
      <div
        [class.error]="commentText.trim().length >= maxSymbol"
        class="input-block">
        <textarea
          [(ngModel)]="commentText"
          (input)="saveData()"
          id="comment"
          class="input"
          placeholder=" ">
        </textarea>
        <label
          for="comment"
          class="placeholder">
          {{'AGREEMENT.COMMENT' | translate}}
        </label>
        <ng-container *ngIf="commentText.trim().length >= maxSymbol">
      <span
        class="input-block__error">
        {{'AGREEMENT.MAX_LENGTH' | translate}} {{maxSymbol}}
      </span>
        </ng-container>
        <ng-container *ngIf="commentText.length < maxSymbol">
      <span
        class="input-block__error count">
        {{commentText.length}} / {{maxSymbol}}
      </span>
        </ng-container>
      </div>
    </div>

    <div id="form-frame__body-file" class="form-frame__body-file">
      <ngx-file-drop
        dropZoneLabel="Drop files here"
        (onFileDrop)="dropped($event)"
        (onFileOver)="fileOver($event)"
        (onFileLeave)="fileLeave($event)">
        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
          <button
            (click)="openFileSelector()"
            type="button"
            class="download-btn">
            <img src="assets/img/attach.svg" alt="Attach" class="download-btn__image">
            <span class="download-btn__content">
              {{'AGREEMENT.ATTACH' | translate}}
              <span
                class="download-btn__content-description">
                {{'AGREEMENT.DRUG_AND_DROP' | translate}}
              </span>
            </span>
          </button>
        </ng-template>
      </ngx-file-drop>
    </div>

    <ul class="form-frame__body-attach-list">
      <li class="file-item" *ngFor="let item of files; let i = index">
        {{ item.relativePath }}
        <button
          (click)="deleteFile(i)"
          class="file-item__delete">
        </button>
      </li>
    </ul>

    <label class="checkbox">
      <input
        [checked]="personalData"
        (change)="personalData = !personalData"
        type="checkbox"
        class="checkbox__input checkboxItem">
      <span class="checkbox__icon"></span>
      <span
        class="checkbox__name">
          {{'AGREEMENT.PERSONAL_DATA' | translate}}
        </span>
    </label>

    <label class="checkbox">
      <input
        [checked]="agreement"
        (change)="agreement = !agreement"
        type="checkbox"
        class="checkbox__input checkboxItem">
      <span class="checkbox__icon"></span>
      <span
        class="checkbox__name">
        {{'AGREEMENT.READ' | translate}}
        <a routerLink="/agreement" target="_blank">{{'AGREEMENT.LINK' | translate}}</a>
        {{'AGREEMENT.AGREEMENT' | translate}}
      </span>
    </label>


    <button
      [disabled]="commentText.length >= maxSymbol || !personalData || !agreement"
      (click)="sendForm()"
      class="btn btn-accent">
      {{'AGREEMENT.SEND' | translate}}
    </button>

    <app-lang-select></app-lang-select>
  </div>
</div>
